/* eslint-disable no-useless-escape */
import { Breakpoint } from '@nx-averycom/shared/avry-models';

const useBreakpoint = (): Breakpoint => {
  const currentWidthSize = window.innerWidth;

  if (currentWidthSize < 576) {
    return 'xs';
  } else if (currentWidthSize >= 576 && currentWidthSize < 768) {
    return 'sm';
  } else if (currentWidthSize >= 768 && currentWidthSize < 992) {
    return 'md';
  } else if (currentWidthSize >= 992 && currentWidthSize < 1200) {
    return 'lg';
  } else if (currentWidthSize >= 1200 && currentWidthSize < 1400) {
    return 'xl';
  } else {
    return 'xxl';
  }
};

const isMobileDevice = (breakpoint: Breakpoint): boolean => {
  return breakpoint == 'xs' || breakpoint == 'sm' || breakpoint == 'md'
    ? true
    : false;
};

const isMobile = (breakpoint: Breakpoint): boolean => {
  return breakpoint == 'xs' || breakpoint == 'sm' ? true : false;
};

const isTablet = (breakpoint: Breakpoint): boolean => {
  return breakpoint == 'md' ? true : false;
};

const fromHexToUtf8 = (data: string): string =>
  data.includes('&#x22;') ? data.replace(/\&\#x22\;/g, '"') : data;

export { useBreakpoint, isMobileDevice, isMobile, isTablet, fromHexToUtf8 };
